import React from "react";

import VStack from "../../ui_atoms/VStack";

import { WorkingTimeComponentProps } from "./helpers";

import Text from "../Text";

const PackageClassicComponent: React.FC<WorkingTimeComponentProps> = () => {
    return (
        <VStack>
            <Text>
                PackageClassicComponent has no input, it his skipped by the Create Mission Context.
                It should not be displayed in production
            </Text>
        </VStack>
    );
};

export default PackageClassicComponent;
